import React, { useEffect, useState } from 'react';
import * as FeatherIcon from 'react-feather';
import './index.css';

const Info = ({ size, content, isMaximized }) => {
    const [visible, setVisible] = useState(false);
    const handleVisible = () => {
        setVisible((prevState) => !prevState);
    };

    return (
        <div title="info" className="info-container mb-2 ml-1" onClick={handleVisible}>
            {/* Info Icon */}
            <FeatherIcon.Info size={size} />
            {/* Info Content */}
            {visible && (
                <div
                    className="visible-container"
                    style={{ width: isMaximized ? '450px' : '250px', height: isMaximized ? '142px' : '110px' }}
                >
                    <table>
                        <thead>
                            <tr>
                                <th className="info-table-border ">Type</th>
                                <th className="info-table-border">Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            {content.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td className="info-table-border text-nowrap w-25">{item.type}</td>
                                        <td className="info-table-border text-left mx-auto">{item.desp}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default Info;
